import { ErrorPageTemplate } from '@/components/Templates/ErrorPageTemplate/ErrorPageTemplate';
import useTranslation from '@/hooks/useTranslation';
import { ErrorPage } from './ErrorPage';

export const UnavailableForLegalReasonsPage = ({ ...rest }) => {
    const { t } = useTranslation();
    return <ErrorPage title={t('Feedback.sorryHeading')} message={t('Feedback.regulatory_restriction')} {...rest} />;
};

export const UnavailableForLegalReasonsPageStandalone = () => (
    <ErrorPageTemplate title="No Access">
        <UnavailableForLegalReasonsPage />
    </ErrorPageTemplate>
);
